<div class="credit-flows">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field class="search">
          <input matInput type="text" [readonly]="loader.tableLoading.inProgress$ | async" placeholder="Search cron job..." [formControl]="formControlSearch">
          <span class="mdi mdi-magnify" matPrefix></span>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-12 mt-2">
        <mat-form-field>
          <mat-label>Cron Job</mat-label>
          <mat-select [(value)]="selectedCronJob" (selectionChange)="onCronJobSelected($event.value)">
            @for (cronJob of cronJobs; track cronJob) {
              <mat-option
                [value]="cronJob.id">
                {{cronJob.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-3 col-md-12 mt-2">
        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select [(value)]="selectedStatus" (selectionChange)="onStatusSelected($event.value)">
            @for (status of statuses; track status) {
              <mat-option
                [value]="status.name"
                >
                {{status.type}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
 
    <div class="row">
        <div class="col-12">
            @if (loader.tableLoading.inProgress$ | async) {
                <custom-content-loader type="list"></custom-content-loader>
              }
              <div [ngClass]="{hidden: (loader.tableLoading.inProgress$ | async), 'table-section': true, 'pb-3': true}">
                <table mat-table [dataSource]="displayedData" multiTemplateDataRows class="width-100 mb-2" [trackBy]="trackByFn">
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef >ID</th>
                    <td mat-cell *matCellDef="let element" class="td-width ellipsis">{{element.id}}</td>
                  </ng-container>

                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef >Name</th>
                    <td mat-cell *matCellDef="let element" class="td-width ellipsis" [matTooltip]="element.cronJobName || '-'"
                    [matTooltipDisabled]="!element.cronJobName || element.cronJobName.length <= 20">
                    {{element.cronJobName || '-'}}
                  </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef >Status</th>
                    <td mat-cell *matCellDef="let element" class="">
                      @if (element.status === 'success') {
                        <span matTooltip="Success" class="mdi mdi-check-circle-outline icon-margin icon-primary text-success"></span>
                      }
                      @if (element.status === 'failed') {
                        <span matTooltip="Failed" class="mdi mdi-cancel icon-margin text-danger"></span>
                      }
                      @if (element.status === 'started') {
                        <span matTooltip="Started" class="mdi mdi-clock-outline icon-margin icon-primary text-primary"></span>
                      }
                  </td>
                  </ng-container>

                  <ng-container matColumnDef="createdTime">
                    <th mat-header-cell *matHeaderCellDef >Created Time</th>
                    <td mat-cell *matCellDef="let element" class="">
                      {{moment(element.createdTime).format('DD/MM/YYYY HH:mm:ss')}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="completedTime">
                    <th mat-header-cell *matHeaderCellDef >Completed Time</th>
                    <td mat-cell *matCellDef="let element" class="">
                      {{ element.completedTime ? moment(element.completedTime).format('DD/MM/YYYY HH:mm:ss') : ''}}
                    </td>
                  </ng-container>
                  
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element;" class=" expanded-row" [attr.colspan]="columnsToDisplay.length">
                      <div class=" example-element-detail"
                        [@detailExpand]="element.id === expandedElementId ? 'expanded' : 'collapsed'">
                          <div class="row mt-3 mb-5">
                            <div class="col-3 title">Error Message</div>
                            <div class="col-9">{{element.errorMessage}}</div>
                          </div>
                      </div>
                    </td>
                  </ng-container>
            
                  <tr mat-header-row *matHeaderRowDef="columnsToDisplay ; sticky: true"></tr>
                  <tr mat-row *matRowDef="let element; columns: columnsToDisplay" class="example-element-row"
                    [class.example-expanded-row]="element.id === expandedElementId"
                    (click)="clickRow(element)"></tr>
                  <tr class="example-detail-row"
                      [ngClass]="{'example-detail-row-expanded': expandedElementId && expandedElementId === row.id}"
                      [ngStyle]="{'display': expandedElementId && expandedElementId === row.id ? null : 'none'}"
                      mat-row
                      *matRowDef="let row; columns: ['expandedDetail']"></tr>
                </table>
                @if (total) {
                  <app-custom-paginator [length]="total" [pageIndex]="offset" [pageSize]="limit"
                  [pageSizeOptions]="[10, 20, 25, 50, 100]" (page)="onPagination($event)"></app-custom-paginator>
                }
              </div>
        </div>
    </div>
</div>
